import * as React from "react";
import { ActorNamesProvider } from "@authe/ui-core/audit";
import { useActorDirectory } from "./useActorDirectory";

/** A display-only union of authorized rosters, not the active team's assignee/mention list. */
export function DashboardActorNames({ children }: { children: React.ReactNode }): React.ReactElement {
  const names = useActorDirectory();
  return <ActorNamesProvider names={names}>{children}</ActorNamesProvider>;
}
